import preparedReducer from './reducer';
import { requestBISiteVisits, requestBISiteVisitsByDate, requestBISiteVisitsBySiteAndDate } from './actions';

export const reducer = preparedReducer;

export const SLICE_NAME = 'biSiteVisits';

export const selectors = (state) => state[SLICE_NAME];

export const actions = {
  requestBISiteVisits,
  requestBISiteVisitsByDate,
  requestBISiteVisitsBySiteAndDate,
};
